import {
  Role,
  RolesList,
  PermissionMatrix,
  RolePermissionMatrix,
} from '@/types/user';
import { apiClient } from '@/utils/api-client';

class RoleService {
  // Role management methods
  async getRoles(params?: {
    skip?: number;
    limit?: number;
    include_system?: boolean;
  }): Promise<RolesList> {
    return apiClient.get<RolesList>('/roles', { params });
  }

  async getRoleById(id: string): Promise<Role> {
    return apiClient.get<Role>(`/roles/${id}`);
  }

  async createRole(roleData: {
    name: string;
    display_name: string;
    description?: string;
    color?: string;
    icon?: string;
    priority?: number;
    permission_ids?: string[];
    parent_role_id?: string;
  }): Promise<Role> {
    return apiClient.post<Role>('/roles', roleData);
  }

  async updateRole(
    id: string,
    roleData: {
      display_name?: string;
      description?: string;
      color?: string;
      icon?: string;
      priority?: number;
      permission_ids?: string[];
      parent_role_id?: string;
    }
  ): Promise<Role> {
    return apiClient.put<Role>(`/roles/${id}`, roleData);
  }

  async deleteRole(id: string): Promise<{ success: boolean }> {
    return apiClient.delete(`/roles/${id}`);
  }

  async assignRolePermissions(
    id: string,
    permissionIds: string[]
  ): Promise<{ success: boolean }> {
    return apiClient.put(`/roles/${id}/permissions`, permissionIds);
  }

  async getPermissionMatrix(): Promise<PermissionMatrix> {
    return apiClient.get<PermissionMatrix>('/roles/matrix');
  }

  async getRolePermissionMatrix(id: string): Promise<RolePermissionMatrix> {
    return apiClient.get<RolePermissionMatrix>(`/roles/${id}/matrix`);
  }

  async initializeRbacSystem(): Promise<{
    permissions_created: number;
    roles_created: number;
    system_initialized: boolean;
  }> {
    return apiClient.post('/roles/initialize', {});
  }
}

export const roleService = new RoleService();
